import { ThemeUIStyleObject } from "theme-ui";

export const containerStyles: ThemeUIStyleObject = {
  position: "relative",
  width: "full",
  height: "full",
  bg: "darkGray",
  zIndex: "dropdown",
  ":after": {
    display: "block",
    content: "''",
    width: "80%",
    height: "200px",
    boxShadow: "floatingXl",
    borderRadius: "full",
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translate3d(-50%, 0, 0)",
  },

  ".videoplayer": {
    height: "100%",
  },
};

export const overlayStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  height: "full",
  width: "full",
  cursor: "pointer",
  bg: "darkGray",
  p: 0,
  border: 0,
  ":focus": {
    boxShadow: "none",
  },
};

export const overlayOpenStyles: ThemeUIStyleObject = {
  height: "65px",
  width: "65px",
  top: "50%",
  left: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  background: "none",
  visibility: "visible",
};

export const imageStyles = (hide: boolean): ThemeUIStyleObject => ({
  visibility: hide ? "hidden" : "visible",
});

export const playIconStyles = (hide: boolean): ThemeUIStyleObject => ({
  position: "absolute",
  zIndex: 2,
  top: "50%",
  left: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  visibility: hide ? "hidden" : "visible",
  width: "65px",
  height: "65px",

  backgroundImage:
    "linear-gradient(to bottom, transparent 0%, transparent 50%, white 50%, white 100%)",
  backgroundSize: "100% 200%",

  backgroundPosition: "0 0%",
  transition: "background-position 0.3s",

  "path + path": {
    transition: "fill 0.3s",
  },
  "button:hover &, button:focus &": {
    backgroundPosition: "100% 100%",
    "path + path": {
      fill: "darkGray",
    },
  },
});

export const VideoWrapperStyles: ThemeUIStyleObject = {
  "&, > div, iframe": {
    height: "100%",
  },
};
